import React from "react";
import { ArrowRightIcon, CheckIcon, GlobeIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { finalIncludes, pathwaySteps } from "../data/content";
export function FinalCTA() {
  return <section className="bg-brand-950 px-5 py-16 text-white md:px-8 md:py-24" data-id="element-123" data-mp="84xkuh4g4316">
      <div className="mx-auto max-w-3xl text-center" data-id="element-124" data-mp="m4ouk5nxix9d">
        <h2 className="text-3xl font-extrabold leading-tight tracking-tight md:text-[2.6rem]" data-id="element-125" data-mp="m3dr66yebris">
          Your next perimenopause consultation deserves a clearer workflow.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-brand-100" data-id="element-126" data-mp="vtghu0i1otdy">
          Turn scattered symptoms, clinical findings, and management considerations into one structured assessment
          and documented care plan.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm font-extrabold uppercase tracking-wide text-gold-300" data-id="element-127" data-mp="14tdcqjv12ohg">
          {pathwaySteps.map((s, i) => <React.Fragment key={s.step} data-id="element-128" data-mp="2c6r9g3ymy6m0" data-mpi={i}>
              <span data-id="element-129" data-mp="2h37yd0dnsp05">{s.step === "Document & Follow Up" ? "Document" : s.step}</span>
              {i < pathwaySteps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-130" data-mp="2m1sykzswv8ol" />}
            </React.Fragment>)}
        </div>

        <p className="mt-8 text-base leading-relaxed text-brand-200" data-id="element-131" data-mp="2qzufbe2v6vww">
          Instead of repeatedly building your assessment process from scratch, you'll have a collection of practical
          resources designed to support consistent documentation and individualized clinical reasoning.
        </p>

        <div className="mt-10 rounded-3xl bg-white p-6 text-ink md:p-10" data-id="element-132" data-mp="34vex266ux82q">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-133" data-mp="39rvp3bh6g6l3">Get the complete collection today</p>
          <p className="mt-2 text-lg font-bold text-muted line-through" data-id="element-134" data-mp="3epf44dlp8ne3">$194 comparison value</p>
          <p className="text-6xl font-extrabold tracking-tight text-brand-800 md:text-7xl" data-id="element-135" data-mp="3ir0n8gottxwq">
            Only $27 <span className="text-2xl" data-id="element-136" data-mp="1jlz4wamo1xrm">USD</span>
          </p>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm font-semibold text-muted" data-id="element-137" data-mp="1eqjs7m0ea7ws">
            <GlobeIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-138" data-mp="1shggx1r7a4yk" />
            Automatic currency conversion at checkout
          </p>

          <ul className="mx-auto mt-6 grid max-w-lg gap-2.5 text-left sm:grid-cols-2" data-id="element-139" data-mp="22eun88jetdd5">
            {finalIncludes.map(t => <li key={t} className="flex items-center gap-2 text-base font-semibold" data-id="element-140" data-mp="1xgjczwp7d0ue">
                <CheckIcon className="h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="2bg178rl9p6b5" />
                {t}
              </li>)}
          </ul>

          <div className="mt-8 text-left" data-id="element-142" data-mp="h1i6oukadcvr">
            <ScarcityBar data-id="element-143" data-mp="h2jjp4kv49g4" />
          </div>
          <div className="mt-6" data-id="element-144" data-mp="h3bcy8qzlv38">
            <CTAButton label="Yes! I want to organize my next perimenopause case" pulse className="md:w-full" data-id="element-145" data-mp="d0enpz6xz0qb" />
          </div>
          <div className="mt-8 border-t border-brand-100 pt-7" data-id="element-146" data-mp="2x9cf7uqeveo">
            <Countdown data-id="element-147" data-mp="6y31w5ntoi9o" />
          </div>
        </div>

        <p className="mt-8 text-lg font-semibold text-brand-100" data-id="element-148" data-mp="6wrwk1eqb2gg">
          Make your next clinical assessment more structured, organized, and easier to document.
        </p>
      </div>
    </section>;
}